import axios from '../axios'

var ComplexProvider = function () {
  return {
    async GetStatusUpdatesAsync (uniqueId, componentId, range) {
      return axios.get('/influx/complex/' + uniqueId + '/' + componentId + '/' + range)
    }
  }
}
export default new ComplexProvider()



// WEBPACK FOOTER //
// ./src/providers/ComplexProvider.js